import SearchableQuerySelector from "components/shared/SearchableQuerySelector";
import { FETCH_TEAMS } from "pages/teams/graphql";

const sortTeams = (teams = []) =>
  [...teams].sort((a, b) => a.name.localeCompare(b.name));

const MSTeamSelector = ({
  query = FETCH_TEAMS,
  value,
  onChange,
  disabled,
  autoFocus,
  className = "",
}) => (
  <SearchableQuerySelector
    className={className}
    query={query}
    queryVariables={{}}
    buildQueryVariables={() => ({})}
    resolveOptions={(data, { searchText }) =>
      sortTeams(data?.teamsList || []).filter((team) => {
        if (!searchText) return true;
        const keyword = searchText.toLowerCase();
        return (
          team.name?.toLowerCase().includes(keyword) ||
          team.description?.toLowerCase().includes(keyword) ||
          team.visibility?.toLowerCase().includes(keyword)
        );
      })
    }
    optionView={(team) => <div>{team.name}</div>}
    valueView={value ? <div>{value.name}</div> : null}
    onSelect={onChange}
    disabled={disabled}
    placeholder="Select a team"
    loadingText="Loading teams..."
    emptyText="No team found"
    autoFocus={autoFocus}
  />
);

export default MSTeamSelector;
